import { useRef, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import ReCAPTCHA from "react-google-recaptcha";
import sha256 from "sha256";
import {
  encodeBase64,
  encryptDecrypt,
} from "../../modules/helpers/validations";
import ButtonClose from "../../modules/homeout/principal/components/modal/ButtonClose";
import SidebarActivarCuenta from "./SidebarActivarCuenta";
import { getSession, postLogin } from "../../services/serviceVivetuseguro";
import * as CryptoJS from "crypto-js";

import SidebarPassword from "./SidebarPassword";

const SidebarLogin = ({
  infoApi,
  show,
  setShow,
  setShowModalSuccess,
  setShowModalActivaSuccess,
  setObjUsuarioLogin,
  setLoading,
}) => {
  const handleClose = () => {
    setShow(false);
    setMensajeErrorCorreo("");
    setMensajeErrorPass("");
    setMensaje("");
    setForm({
      user: "",
      password: "",
    });
  };
  const [typeField, setTypeField] = useState(false);
  const [typeInput, setTypeInput] = useState("password");
  const [urlApi, setUrlApi] = useState("");
  const [codRecaptcha, setCodRecaptcha] = useState("");
  const [showModalActivar, setShowModalActivar] = useState(false);
  const [showModalPassword, setShowModalPassword] = useState(false);
  const [mensaje, setMensaje] = useState("");

  const [mensajeErrorCorreo, setMensajeErrorCorreo] = useState("");
  const [mensajeErrorPass, setMensajeErrorPass] = useState("");

  // RECAPTCHA
  const recaptchaRef = useRef();

  const [form, setForm] = useState({
    user: "",
    password: "",
  });

  const handleChange = (e) => {
    document.getElementById(e.target.id).style.borderColor =
      "var(--bs-border-color)";
    document.getElementById(e.target.id).style.color =
      "var(--bs-offcanvas-color)";
    if (e.target.id === "user") setMensajeErrorCorreo("");
    if (e.target.id === "password") setMensajeErrorPass("");
    setMensaje("");
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleTypeField = (type) => {
    setTypeField(type);
    setTypeInput(type ? "text" : "password");
  };

  const handleSubmit = async () => {
    setMensajeErrorCorreo("");
    setMensajeErrorPass("");
    setMensaje("");

    let errorCampoVacio = false;
    if (form.user.trim() === "") {
      document.getElementById("user").style.borderColor = "var(--rojo)";
      setMensajeErrorCorreo("Este campo es obligatorio");
      errorCampoVacio = true;
    }
    if (form.password.trim() === "") {
      document.getElementById("password").style.borderColor = "var(--rojo)";
      setMensajeErrorPass("Este campo es obligatorio");
      errorCampoVacio = true;
    }

    if (errorCampoVacio) return;

    const pattern = /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/;
    if (!form.user.trim().match(pattern)) {
      document.getElementById("user").style.borderColor = "var(--rojo)";
      document.getElementById("user").style.color = "var(--rojo)";
      setMensaje("Revisa que contenga @ y los puntos necesarios.");
      return;
    }

    const token = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();

    if (!token) {
      // console.log('err captcha')
      document.getElementById("user").style.borderColor = "var(--rojo)";
      setMensaje("Captcha inválido, actualizar web");
      return;
    }

    setLoading(true);
    let objUsuario = {
      usuario: encodeBase64(form.user),
      password: encodeBase64(
        encryptDecrypt(
          sha256(form.password),
          token.substring(token.length - 10, token.length)
        )
      ),
      sitioPassword: "9B9CB6631B27AA1DF47DB351B497004810015B09",
      sitioUsuario: "CARDIF",
      deviceInfo: "",
      tokenCaptcha: token,
    };

    try {
      const rpta = await postLogin(objUsuario, urlApi);

      if (rpta === undefined) {
        document.getElementById("user").style.borderColor = "var(--rojo)";
        document.getElementById("user").style.color = "var(--rojo)";
        setMensaje("Ocurrió un error al intentar iniciar sesión.");
        setLoading(false);

        return;
      }
      if (rpta.codigo === 0) {
        localStorage.setItem(
          "token",
          CryptoJS.AES.encrypt(
            rpta.data.token,
            process.env.REACT_APP_CRYPTO_PASSPHRASE
          )
        );
        getSession(rpta.data.token, urlApi).then((data) => {
          let res = { data }.data;
          let perfilesActivos = res.perfiles.$values;

          if (perfilesActivos.length === 0) {
            document.getElementById("user").style.borderColor = "var(--rojo)";
            document.getElementById("user").style.color = "var(--rojo)";
            setMensaje("Aun no cuentas con algún seguro activo.");
            setLoading(false);

            return;
          }

          let tieneEcoElemental = false;
          for (var i = 0; i < perfilesActivos.length; i++) {
            if (perfilesActivos[i] === "Empleabilidad") {
              tieneEcoElemental = true;
              break;
            }
          }

          if (tieneEcoElemental === false) {
            document.getElementById("user").style.borderColor = "var(--rojo)";
            document.getElementById("user").style.color = "var(--rojo)";
            setMensaje("Aún no cuentas con tu Seguro de Protección Financiera. ");
            setLoading(false);

            return;
          }

          setLoading(false);

          //Una vez validado que el usuario tenga el Seguro de Vida, se procede a ir al sitio de vivetuseguro pasando el token como parametro.
          let urlVivetuseguro = infoApi[0].urlFront + rpta.data.token + "&modulo=empleabilidad";
          window.open(urlVivetuseguro, "_blank");

          setMensaje("");
          handleClose();
        });
      } else {
        if (rpta.mensaje === "Contraseña incorrecta.") {
          document.getElementById("password").style.borderColor = "var(--rojo)";
          document.getElementById("password").style.color = "var(--rojo)";
        } else {
          document.getElementById("user").style.borderColor = "var(--rojo)";
          document.getElementById("user").style.color = "var(--rojo)";
        }
        setMensaje(rpta.mensaje);
        setLoading(false);
      }
    } catch (err) {
      document.getElementById("user").style.borderColor = "var(--rojo)";
      document.getElementById("user").style.color = "var(--rojo)";
      setMensaje("Hubo un problema en la autenticación.");
      setLoading(false);
    }
  };

  const openRegister = () => {
    handleClose();
    setShowModalActivar(true);
  };

  const openModalPassword = () => {
    handleClose();
    setShowModalPassword(true);
  };

  useEffect(() => {
    if (infoApi?.length < 1 || infoApi === undefined) return;
    infoApi?.forEach((element) => {
      setUrlApi(element.urlApi);
      setCodRecaptcha(element.cod_recaptcha);
    });
  }, [infoApi]);

  return (
    <>
      <SidebarActivarCuenta
        urlApi={urlApi}
        codRecaptcha={codRecaptcha}
        show={showModalActivar}
        setShow={setShowModalActivar}
        setShowLogin={setShow}
        setShowModalActivaSuccess={setShowModalActivaSuccess}
        setObjUsuarioLogin={setObjUsuarioLogin}
        setLoading={setLoading}
      />
      <SidebarPassword
        urlApi={urlApi}
        codRecaptcha={codRecaptcha}
        show={showModalPassword}
        setShow={setShowModalPassword}
        setShowModalSuccess={setShowModalSuccess}
        setLoading={setLoading}
      />

      <Offcanvas show={show} onHide={handleClose} placement="end">
        <ButtonClose close={handleClose} />
        <Offcanvas.Body>
          <div className="sticky__btn__sidebar_up d-lg-block d-none">
            <button
              className="btn__sidebar"
              type="button"
              onClick={handleClose}
            >
              <b>
                INGRESA A TUS
                <br />
                BENEFICIOS AQUÍ
              </b>
              <i className="fa-solid fa-angle-down flecha__sticky__btn"></i>
            </button>
          </div>
          <div className="body__login">
            <h2>Inicia sesión</h2>
            <p>Ingresa tus datos para disfrutar tus beneficios</p>
            <Form
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
              }}
              className="form__modal"
            >
              <div className="row justify-content-center">
                <label className="label__text">
                  <b>Correo electrónico</b>
                </label>
                <div className="col-12">
                  <input
                    type="text"
                    className="form-control border-input "
                    id="user"
                    name="user"
                    placeholder="Ingresa tu correo"
                    autoComplete="off"
                    value={form.user}
                    onChange={handleChange}
                  />
                </div>
                {mensajeErrorCorreo !== "" && (
                  <div className="texto__error__campo">
                    <p>{mensajeErrorCorreo}</p>
                  </div>
                )}
                {mensaje !== "" && mensaje !== "Contraseña incorrecta." && (
                  <div className="texto__error__campo">
                    <p>{mensaje}</p>
                  </div>
                )}
                <label className="label__text">
                  <b>Contraseña</b>
                </label>
                <div className="col-12 login__pass">
                  <input
                    type={typeInput}
                    className="form-control border-input "
                    id="password"
                    name="password"
                    placeholder="Ingresa tu contraseña"
                    autoComplete="off"
                    value={form.password}
                    onChange={handleChange}
                  />
                  {typeField ? (
                    <i
                      onClick={() => handleTypeField(!typeField)}
                      className="fa-solid fa-eye pass__icon"
                    ></i>
                  ) : (
                    <i
                      onClick={() => handleTypeField(!typeField)}
                      className="fa-solid fa-eye-slash pass__icon"
                    ></i>
                  )}
                </div>
                {mensajeErrorPass !== "" && (
                  <div className="texto__error__campo">
                    <p>{mensajeErrorPass}</p>
                  </div>
                )}
                {mensaje === "Contraseña incorrecta." && (
                  <div className="texto__error__campo">
                    <p>{mensaje}</p>
                  </div>
                )}
                <div
                  className="col-12 recuperar__pass"
                  onClick={openModalPassword}
                >
                  <p>¿Olvidaste tu contraseña?</p>
                </div>
                <div style={{ textAlign: "center" }} className="col-12 mb-4">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    size="invisible"
                    sitekey={codRecaptcha}
                  />
                  <div className="d-sm-none">
                    <button
                      className="btn__azul"
                      style={{ padding: "1rem 7rem" }}
                      onClick={handleSubmit}
                    >
                      Iniciar sesión
                    </button>
                  </div>
                  <div className="d-none d-md-block">
                    <button className="btn__azul" onClick={handleSubmit}>
                      ENTRAR
                    </button>
                  </div>
                </div>
              </div>
              <div className="div__registrate__aqui">
                <p>
                  ¿Aún no tienes una cuenta?{" "}
                  <span
                    style={{ color: "var(--rojo)", cursor: "pointer" }}
                    onClick={openRegister}
                  >
                    Regístrate aquí
                  </span>
                </p>
              </div>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default SidebarLogin;
